import type { BidIncrements } from '@/types/BidIncrement';
import type { Catalog } from '@/types/Catalog';
import type { Seller } from '@/types/Seller';
import type { TypedActionWithPayload } from '@/types/redux';

/* Action Types */
export const LOAD_CATALOGS_FAIL = 'la/domain/catalogs/LOAD_FAIL';
export const LOAD_CATALOGS_REQUEST = 'la/domain/catalogs/LOAD_REQUEST';

export const LOAD_CATALOGS_SUCCESS = 'la/domain/catalogs/LOAD_SUCCESS';
export type LOAD_CATALOGS_SUCCESS_ACTION = TypedActionWithPayload<
    typeof LOAD_CATALOGS_SUCCESS,
    {
        bidIncrements: BidIncrements[];
        catalogs: Catalog[];
        sellers: Seller[];
    },
    {
        actionTime: number;
        catalogIds: number[];
    }
>;
